const InputContainer = ({ children }) => {
    return (
        <div className='d-flex flex-column justify-content-center align-items-start mb-3'>
            {children}
        </div>
    );
};

export default InputContainer;